<template>
  <div>
    <div class="d-flex align-items-end justify-content-between mb-3">
      <span class="required-fields">
        {{ $t("pages.details.requiredFields") }}
      </span>
      <el-button
        type="primary"
        @click="edit = !edit"
        :key="'edit-button'"
        v-if="!edit"
      >
        <font-awesome-icon icon="fa-light fa-pencil" class="mr-2" />
        {{ $t("pages.details.editButton") }}
      </el-button>
    </div>
    <card>
      <div class="d-flex">
        <HorizontalDetailTitle
          :label="$t('sections.alarms.fields.alarm')"
          class="mr-4"
        />
        <HorizontalDetailInput
          :field="alarm.alarm"
          :edit="false"
          class="flex-1"
        />
      </div>
      <div class="d-flex mt-4">
        <div class="d-flex mr-5">
          <HorizontalDetailTitle
            :label="$t('sections.alarms.fields.module')"
            class="mr-4"
          />
          <HorizontalDetailInput :field="alarm.module" :edit="false" />
        </div>
        <div class="d-flex">
          <HorizontalDetailTitle
            :label="$t('sections.alarms.fields.status')"
            class="mr-4"
          />
          <HorizontalDetailInput
            :field="alarm.status"
            type="dropdown"
            :options="$t('sections.alarms.fields.statusOptions')"
            :edit="edit"
            @input="(e) => onInput('status', e)"
          />
        </div>
      </div>
    </card>
    <card v-if="edit">
      <span class="section-title">
        {{ $t("sections.alarms.fields.notes") }}
      </span>
      <HorizontalDetailInput
        :field="notes"
        type="textarea"
        :edit="true"
        class="mt-3"
        @input="
          (e) => {
            this.wasEdited = true;
            this.notes = e;
          }
        "
      />
    </card>
    <span class="section-title">
      {{ $t("sections.alarms.fields.history") }}
    </span>
    <AlarmDetailHistoryTable :history="alarm.history" />
    <div class="d-flex justify-content-end mt-3" v-if="edit">
      <el-button @click="handleCancel" class="outline-button">
        {{ $t("pages.details.cancelButton") }}
      </el-button>
      <el-button
        type="primary"
        @click="handleSave"
        :disabled="!wasEdited || !validFields"
      >
        {{ $t("pages.details.saveButton") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import AlarmDetailHistoryTable from '@/components/sections/alarms/AlarmDetailHistoryTable';

export default {
  name: 'AlarmsDetail',
  components: {
    HorizontalDetailTitle,
    HorizontalDetailInput,
    AlarmDetailHistoryTable,
  },
  data() {
    return {
      edit: false,
      wasEdited: false,
      alarm: {
        module: undefined,
        status: undefined,
        alarm: undefined,
      },
      savedAlarm: {
        module: undefined,
        status: undefined,
        alarm: undefined,
      },
      notes: undefined,
      history: [],
    };
  },
  computed: {
    validModule() {
      return (
        this.updatedAlarmSetting.module === undefined
        || this.updatedAlarmSetting.module.length > 0
      );
    },
    validMessage() {
      return (
        this.updatedAlarmSetting.message === undefined
        || this.updatedAlarmSetting.message.length > 0
      );
    },
    validParams() {
      return this.updatedAlarmSetting.params.every(
        (param) => param.value !== null && param.value.length > 0,
      );
    },
    validFields() {
      /* return (
        this.updatedAlarmSetting.module
        && this.validModule
        && this.updatedAlarmSetting.message
        && this.validMessage
        && this.validParams
        && this.updatedAlarmSetting.emailGroups != null
      ); */
      return true;
    },
  },
  async created() {
    if (this.$route.params.id) {
      if (!this.$route.params.alarm) {
        this.alarm = cloneDeep(
          await this.$store.dispatch('getAlarm', this.$route.params.id),
        );
      } else {
        this.alarm = cloneDeep(this.$route.params.alarm);
      }
      this.savedAlarm = cloneDeep(this.alarm);
    }
  },
  methods: {
    onInput(field, value) {
      this.wasEdited = true;
      this.alarm[field] = value;
    },
    async handleSave() {
      try {
        await this.$store.dispatch('editAlarm', {
          id: this.alarm.id,
          status: this.alarm.status,
          notes: this.notes,
        });
        this.$message.success(
          this.$t('components.alerts.editSuccess', { type: 'alarm' }),
        );
        this.$router.push({
          name: 'Alarms',
        });
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.editError', { type: 'alarm' }),
        );
      }
    },
    handleCancel() {
      if (this.wasEdited) {
        this.$confirm(this.$t('pages.details.confirm.message'), '', {
          confirmButtonText: this.$t('pages.details.yesButton'),
          cancelButtonText: this.$t('pages.details.cancelButton'),
          cancelButtonClass: 'outline-button',
        })
          .then(() => {
            this.alarm = cloneDeep(this.savedAlarm);
            this.wasEdited = false;
            this.edit = false;
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('pages.details.confirm.cancelMessage'),
            });
          });
      } else {
        this.alarm = cloneDeep(this.savedAlarm);
        this.wasEdited = false;
        this.edit = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.status-message {
  white-space: pre-line;
}

.flex-1 {
  flex: 1;
}
</style>
